import { Helmet } from 'react-helmet';
import { Box, Button, Divider, Typography } from '@mui/material';
import { useAccount } from '../../contexts/Account';

function AnimatedRedirect() {
  const { currentPlan, isFreemium } = useAccount();

  function getIndefiniteArticle() {
    if (isFreemium) return 'a';
    const word = currentPlan?.salesforceValues?.tier;
    if (!word || typeof word !== 'string') return 'a';
    const firstLetter = word.trim()[0].toLowerCase();
    return ['a', 'e', 'i', 'o', 'u'].includes(firstLetter) ? 'an' : 'a';
  }

  return (
    <>
      <Helmet>
        <title>Loading Profile - AdvisoryCloud</title>
      </Helmet>

      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: { xxs: '24px', xs: '0px' },
        }}
      >
        <iframe
          src="https://cdn.advisorycloud.com/static-content/loading-v2.html"
          title="Loading Profile"
          frameBorder="0"
          style={{
            width: '100%',
            height: '400px',
            overflowX: 'visible',
            marginBottom: '80px',
          }}
        />
        {(currentPlan?.salesforceValues?.tier || isFreemium) && (
          <Typography
            align="center"
            sx={{ mb: 3, fontSize: '16px', color: '#000' }}
          >
            You are on {getIndefiniteArticle()}{' '}
            {isFreemium ? 'Starter' : currentPlan.salesforceValues.tier} plan,
            upgrade at any time
            <Divider
              sx={{
                borderColor: 'white',
                display: { xxs: 'none', xs: 'block' },
              }}
            />{' '}
            for full access.
          </Typography>
        )}
        <Button
          type="button"
          variant="contained"
          color="primary"
          id="aobf-continue-button"
          onClick={() => {
            window.location.replace(currentPlan.onboardingRedirectUrl);
          }}
          sx={{
            borderRadius: '50px',
            backgroundColor: '#3171F6',
            '&:hover': { backgroundColor: '#3171F6' },
            height: '48px',
            textTransform: 'none',
            fontSize: '16px',
            fontWeight: 700,
            width: { xxs: '100%', xs: '232px' },
          }}
        >
          View Dashboard
        </Button>
      </Box>
    </>
  );
}

export default AnimatedRedirect;
